/**
 * Session-only: after landing login, open this practice question on /dashboard.
 * Separate from practiceQuestionStorage (currentInterview) which holds an in-progress attempt.
 */

const PENDING_PRACTICE_QUESTION_AFTER_LOGIN_KEY = 'pendingPracticeQuestionAfterLogin'

export function setPendingPracticeQuestionAfterLogin(questionId: string): void {
  if (typeof window === 'undefined') return
  if (!questionId?.trim()) return
  try {
    sessionStorage.setItem(PENDING_PRACTICE_QUESTION_AFTER_LOGIN_KEY, questionId.trim())
  } catch {
    // ignore
  }
}

/** Read and remove so the open-on-dashboard flow runs at most once. */
export function getAndClearPendingPracticeQuestionAfterLogin(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(PENDING_PRACTICE_QUESTION_AFTER_LOGIN_KEY)
    sessionStorage.removeItem(PENDING_PRACTICE_QUESTION_AFTER_LOGIN_KEY)
    if (typeof raw !== 'string' || raw.trim() === '') return null
    return raw.trim()
  } catch {
    return null
  }
}

export function clearPendingPracticeQuestionAfterLogin(): void {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.removeItem(PENDING_PRACTICE_QUESTION_AFTER_LOGIN_KEY)
  } catch {
    // ignore
  }
}
